/**
 * PeriodSelector Component
 * Dropdown selector for performance period type
 */

import React from 'react';
import { clsx } from 'clsx';
import { Calendar } from 'lucide-react';
import type { PeriodType } from '../../types';
import { PERIOD_LABELS } from '../../types';

export interface PeriodSelectorProps {
  value: PeriodType;
  onChange: (period: PeriodType) => void;
  className?: string;
  disabled?: boolean;
}

export const PeriodSelector: React.FC<PeriodSelectorProps> = ({
  value,
  onChange,
  className,
  disabled = false,
}) => {
  const periods: PeriodType[] = ['monthly', 'quarterly', 'half_yearly', 'yearly'];

  return (
    <div className={clsx('flex items-center gap-2', className)}>
      <Calendar className="w-5 h-5 text-stone-400" />
      <select
        value={value}
        onChange={(e) => onChange(e.target.value as PeriodType)}
        disabled={disabled}
        className={clsx(
          'px-3 py-2 rounded-lg border border-stone-200 bg-white text-stone-700',
          'focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent',
          'disabled:bg-stone-100 disabled:cursor-not-allowed',
          'text-sm font-medium'
        )}
      >
        {periods.map((period) => (
          <option key={period} value={period}>
            {PERIOD_LABELS[period]}
          </option>
        ))}
      </select>
    </div>
  );
};

export default PeriodSelector;
